import { Controller } from "@hotwired/stimulus"

// Counts a wait down to the control it was holding back (#2041): "Resend code
// in 42s" turns into the "Resend code" button. Setting the seconds value
// starts it again.
export default class extends Controller {
  static targets = ["remaining", "waiting", "ready"]
  static values = { seconds: { type: Number, default: 0 } }

  declare readonly remainingTarget: HTMLElement
  declare readonly hasRemainingTarget: boolean
  declare readonly waitingTarget: HTMLElement
  declare readonly readyTarget: HTMLElement
  declare secondsValue: number

  #timer: ReturnType<typeof setTimeout> | undefined

  disconnect() {
    clearTimeout(this.#timer)
  }

  secondsValueChanged() {
    clearTimeout(this.#timer)
    const seconds = Math.max(0, Math.ceil(this.secondsValue))
    if (this.hasRemainingTarget)
      this.remainingTarget.textContent = String(seconds)
    this.waitingTarget.hidden = seconds === 0
    this.readyTarget.hidden = seconds > 0
    if (seconds > 0)
      this.#timer = setTimeout(() => (this.secondsValue = seconds - 1), 1_000)
  }
}
